import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

export default function PrivateLoginRoute() {
    let  userid = localStorage.getItem("token") == null ? true : false;
    let department = parseInt(localStorage.getItem("department"));
    let level = parseInt(localStorage.getItem("level"));

    if(userid===true)
    {
	    return (
			<>
				{userid ? <Outlet  /> : <Navigate to="/overview" />}
			</>
        )
	}else{
		if(level===1)
        {
        	if(department===1)
        	{
        		return <><Navigate to="/hr-creation" /></>;
        	}else if(department===2)
        	{
        		return <><Navigate to="/dashboard-sales-vp-of-sales-representative" /></>;
        	}else if(department===3)
        	{
        		return <><Navigate to="/merchant-overview" /></>;
        	}else if(department===4)
        	{
        		return <><Navigate to="/customer-overview" /></>;
        	}else if(department===5)
        	{
        		return <><Navigate to="/overview" /></>;
        	}else if(department===6)
        	{
        		return <><Navigate to="/overview" /></>;
        	}
        }else if(level===2)
        {
        	if(department===1)
        	{
        		return <><Navigate to="/hr-creation" /></>;                                                                                                                                                                                                                                                             
        	}else if(department===2)
        	{
        		return <><Navigate to="/dashboard-sales-vp-of-sales-representative" /></>;
        	}else if(department===3)
        	{
        		return <><Navigate to="/merchant-overview" /></>;
        	}else if(department===4)
        	{
        		return <><Navigate to="/customer-overview" /></>;
        	}else if(department===5)
        	{
        		return <><Navigate to="/overview" /></>;
        	}else if(department===6)
        	{
        		return <><Navigate to="/overview" /></>;
        	}
        }else if(level===3)
        {
        	if(department===1)
        	{
        		return <><Navigate to="/hr-creation" /></>;
        	}else if(department===2)
        	{
        		return <><Navigate to="/dashboard-sales-vp-of-sales-representative" /></>;
        	}else if(department===3)
        	{
        		return <><Navigate to="/merchant-overview" /></>;
        	}else if(department===4)
        	{
        		return <><Navigate to="/customer-overview" /></>;
        	}else if(department===5)
        	{
        		return <><Navigate to="/overview" /></>;
        	}else if(department===6)
        	{
        		return <><Navigate to="/overview" /></>;
        	}
        }else if(level===4)
        {
        	if(department===1)
        	{
        		return <><Navigate to="/hr-creation" /></>;
        	}else if(department===2)
        	{
        		return <><Navigate to="/dashboard-sales-vp-of-sales-representative" /></>;
        	}else if(department===3)
        	{
        		return <><Navigate to="/merchant-overview" /></>;
        	}else if(department===4)
        	{
        		return <><Navigate to="/customer-overview" /></>;
        	}else if(department===5)
        	{
        		return <><Navigate to="/overview" /></>;
        	}else if(department===6)
        	{
        		return <><Navigate to="/overview" /></>;
        	}
        }else if(level===5)
        {
        	if(department===1)
        	{
        		return <><Navigate to="/hr-creation" /></>;
        	}else if(department===2)
        	{
        		return <><Navigate to="/dashboard-sales-vp-of-sales-representative" /></>;
        	}else if(department===3)
        	{
        		return <><Navigate to="/merchant-overview" /></>;
        	}else if(department===4)
        	{
        		return <><Navigate to="/customer-overview" /></>;
        	}else if(department===5)
        	{
        		return <><Navigate to="/overview" /></>;
            }else if(department===6)
        	{
        		return <><Navigate to="/overview" /></>;
        	}
        }else if(level===6)
        {
        	if(department===1)
        	{
        		return <><Navigate to="/hr-creation" /></>;
        	}else if(department===2)
        	{
        		return <><Navigate to="/dashboard-sales-vp-of-sales-representative" /></>;
        	}else if(department===3)
        	{
        		return <><Navigate to="/merchant-overview" /></>;
        	}else if(department===4)
        	{
        		return <><Navigate to="/customer-overview" /></>;
        	}else if(department===5)
        	{
        		return <><Navigate to="/overview" /></>;
        	}else if(department===6)
        	{
        		return <><Navigate to="/overview" /></>;
        	}
        }else if(level===7)
        {
        	return (
				<>
					{userid ? <Outlet  /> : <Navigate to="/overview" />}
				</>
			)
        }
	}

}